import { useEffect, useRef } from 'react';
import cloneDeep from 'lodash/cloneDeep';
const usePreviousValue = <T,>(value: T): T | undefined => {
  let localValue = value;
  // Clone the value if value is non-primitive to avoid mutations.
  if (typeof value === 'object' || typeof value === 'function') {
    localValue = cloneDeep(value);
  }
  const ref = useRef<T>();
  useEffect(() => {
    ref.current = localValue;
  }, [localValue]);
  // eslint-disable-next-line react-hooks/refs
  return ref.current;
};
export default usePreviousValue;